export default __webpack_public_path__ + "static/media/thankyoukeyvis_voucher50_tab_roi.c776647b.png";